import { animateScroll } from 'react-scroll';

export function getPosition(el) {
  var xPos = 0;
  var yPos = 0;

  while (el) {
    if (el.tagName == "BODY") {
      // deal with browser quirks with body/window/document and page scroll
      var xScroll = el.scrollLeft || document.documentElement.scrollLeft;
      var yScroll = el.scrollTop || document.documentElement.scrollTop;

      xPos += (el.offsetLeft - xScroll + el.clientLeft);
      yPos += (el.offsetTop - yScroll + el.clientTop);
    } else {
      // for all other non-BODY elements
      xPos += (el.offsetLeft - el.scrollLeft + el.clientLeft);
      yPos += (el.offsetTop - el.scrollTop + el.clientTop);
    }

    el = el.offsetParent;
  }
  return {
    x: xPos,
    y: yPos
  };
}

export function isScrolledIntoView(el) {
  const rect = el.getBoundingClientRect();
  const elemTop = rect.top;
  const elemBottom = rect.bottom;

  const isVisible = (elemTop <= 150 && elemBottom >= 200);

  return isVisible;
}

const THIN_HEADER_HEIGHT = 60;
const MOBILE_MARGIN = 10;

export function scrollToElement(selector) {
  try {
    const scrollTarget = document.querySelector(selector);
    if (scrollTarget) {
      const elementPosition = getPosition(scrollTarget);
      let animatePosition = window.scrollY + elementPosition.y - THIN_HEADER_HEIGHT;
      if (window.innerWidth <= 767) {
        animatePosition -= MOBILE_MARGIN;
      }
      animateScroll.scrollTo(animatePosition, { duration: 500 });
    }
  } catch (err) {
    console.error(err);
  }
}



// WEBPACK FOOTER //
// ../src/utils/scroll.js